import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vendaArla'
})
export class VendaArlaPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
